import Vue from 'vue'
import moment from 'moment'
import * as constant from './constant'
export const mutations = {
    [constant.STOCK_FINANCIAL_CARD](state, payload) {
        Vue.set(state.stocks, payload.key, payload.value)
    },
    [constant.STOCK_LIST](state, payload) {
        if (payload) {
            state.stockList = payload
        }
    },
    [constant.STOCK_CATEGORIES](state, payload) {
        if (payload) {
            state.stockCategories = payload
        }
    },
    [constant.STOCK_TRENDING_LIST](state, payload) {
        if (payload) {
            state.stockTrendingList = payload
        }
    },
    [constant.STOCK_QUOTE](state, payload) {
        if (payload) {
            state.stockQuote = payload
        }
    },
    [constant.SET_CHART_DATA](state, data) {
        state.chartData = data
    },
    [constant.TOGGLE_CHART_MODAL](state, display) {
        state.isDisplayChartModal = display
    },
    [constant.STOCK_SHAREHOLDER](state, { data }) {
        state.stockShareholder = data
    },
    [constant.STOCK_FUND_QUOTE](state, { data }) {
        state.stockFundQuote = data
    },
    [constant.STOCK_PERIOD](state, payload) {
        if (payload) {
            state.stockCurrentPeriod = payload
        }
    },
    [constant.STOCK_GRAPH_PERIOD](state, payload) {
        if (payload) {
            state.stockPeriod = payload
        }
    },
    [constant.STOCK_UNIT_TYPE](state, payload) {
        if (payload) {
            state.stockCurrentUnitType = payload
        }
    },
    [constant.STOCK_TIMESTAMP_1D](state, payload) {
        if (payload) {
            state.stockTimestamp1D = payload
        }
    },
    [constant.STOCK_NAV](state, payload) {
        let arr = []
        let v
        if (payload && payload.c) {
            for (let i = 0; i < payload.c.length; i++) {
                if (state.stockCurrentUnitType == 'price') {
                    v = payload.c[i]
                } else {
                    v = payload.v[i]
                }
                let nav_date = moment.unix(payload.t[i]).format("YYYY-MM-DD")
                let d = moment.unix(parseInt(payload.t[i])).utc()._d
                arr = [...arr, {
                    amount: payload.v[i],
                    v,
                    nav_date,
                    value: v,
                    d
                }]
            }
            state.stockNav = arr
        } else {
            payload = []
        }
    },
    [constant.STOCK_NAV_1D](state, payload) {
        let arr = []
        let v
        if (payload && payload.c) {
            for (let i = 0; i < payload.c.length; i++) {

                v = payload.c[i]

                let nav_date = moment.unix(payload.t[i]).format("YYYY-MM-DD")
                let d = moment.unix(parseInt(payload.t[i])).utc()._d
                arr = [...arr, {
                    amount: payload.v[i],
                    v,
                    nav_date,
                    value: v,
                    d
                }]
            }
            state.stockNav1D = arr
        } else {
            payload = []
        }
    },
    [constant.STOCK_RANKING](state, { payload, period = "1Y" }) {
        if (payload) {
            period = period.toUpperCase()
            state.stockFilter = [] // clear old data
            payload.forEach(item => {
                state.stockFilter.push({
                    id: item.SecurityID,
                    name: item.SecurityName,
                    data_date: item.Date,
                    period: period,
                    percent: item.Perf,
                    price: item.Close,
                })
            });
        }
    },
    [constant.STOCK_FOLLOWING](state, payload) {
        if (payload) {
            state.stockFollowing = payload
        }
    },
}